import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useLanguage } from '../contexts/LanguageContext';
import { Card, CardContent } from './ui/card';
import { Badge } from './ui/badge';
import { Button } from './ui/button';
import { Star, Users, MapPin, Zap } from 'lucide-react';

const CarCard = ({ car }) => {
  const { t } = useLanguage();
  const navigate = useNavigate();

  return (
    <Card className="overflow-hidden hover:shadow-lg transition-all duration-300 group cursor-pointer"
      onClick={() => navigate(`/car/${car.id}`)}>
      <div className="relative aspect-[4/3] overflow-hidden">
        <img
          src={car.images[0]}
          alt={car.name}
          className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-300"
        />
        {car.instantBooking && (
          <Badge className="absolute top-3 right-3 bg-[#bcef3c] text-gray-900 hover:bg-[#a8d92e]">
            <Zap className="w-3 h-3 mr-1" />
            {t('instantBooking')}
          </Badge>
        )}
      </div>
      
      <CardContent className="p-4">
        <div className="space-y-3">
          {/* Title and Type */}
          <div>
            <h3 className="font-semibold text-lg text-gray-900 group-hover:text-[#000000] transition">
              {car.name}
            </h3>
            <div className="flex items-center gap-2 mt-1">
              <Badge variant="outline" className="text-xs">
                {t(car.type.toLowerCase())}
              </Badge>
              <span className="text-sm text-gray-600">{car.transmission}</span>
            </div>
          </div>

          {/* Location */}
          <div className="flex items-center text-sm text-gray-600">
            <MapPin className="w-4 h-4 mr-1" />
            {car.location}
          </div>

          {/* Features */}
          <div className="flex items-center gap-4 text-sm text-gray-600">
            <div className="flex items-center">
              <Users className="w-4 h-4 mr-1" />
              {car.capacity}
            </div>
            <div className="flex items-center">
              <Star className="w-4 h-4 mr-1 fill-yellow-400 text-yellow-400" />
              {car.rating} ({car.trips})
            </div>
          </div>

          {/* Price and Action */}
          <div className="flex items-center justify-between pt-2 border-t">
            <div>
              <span className="text-2xl font-comfortaa font-bold text-ink">${car.price_per_day ?? car.pricePerDay ?? 0}</span>
              <span className="text-sm text-ink-500 ml-1">MXN/{t('perDay')}</span>
            </div>
            <Button 
              size="sm"
              className="bg-ink hover:bg-ink-700 text-white font-comfortaa font-bold"
              onClick={(e) => {
                e.stopPropagation();
                navigate(`/car/${car.id}`);
              }}
            >
              {t('viewDetails')}
            </Button>
          </div>
        </div>
      </CardContent>
    </Card>
  );
};

export default CarCard;